import { parseToRgb, rgba } from 'polished'

export default function setOpacity(opacity, color) {
  const { red, green, blue } = parseToRgb(color)
  return rgba({ red, green, blue, alpha: opacity })
}
